var _style, _g, _rect;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.2 71.5",
    style: {
      enableBackground: "new 0 0 86.2 71.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.53;}\n\t.st1{fill:#A9BFDE;}\n\t.st2{fill:#FCDAD8;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_4_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 311,
    height: 282,
    xlinkHref: "7A04A922ED468AFE.png",
    transform: "matrix(0.48 0 0 0.48 -34.08 -27.86)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.9,19.9c0,22.7-15.4,43.4-38.5,49l0,0C16.3,62.2-0.2,34.8,6.4,7.7l0.5-1.9c18.3,4.5,31.8,18.4,36.5,35.3 C48.2,24.2,61.7,10.3,80,5.7l0.4,2.1C81.4,11.9,81.9,15.9,81.9,19.9z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -73,
    y: -54.4,
    className: "st2",
    width: 81.7,
    height: 41.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrow2);
export default __webpack_public_path__ + "static/media/carousel-arrow2.2b2d75800dc2e77f5275f282b8d59351.svg";
export { ForwardRef as ReactComponent };